import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Field from '../../field';

const Postcode = forwardRef(
  ({ name, required, className, hideOptionalMessage, international }, ref) => (
    <Field
      name={name}
      label={international ? 'Postal code' : 'Postcode'}
      type="text-field"
      autoComplete="postal-code"
      required={required}
      className={className}
      short
      hideOptionalMessage={hideOptionalMessage}
      ref={ref}
    />
  )
);

Postcode.displayName = 'Postcode';

Postcode.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  /** Should "(Optional)" be hidden in the label? */
  hideOptionalMessage: PropTypes.bool,
  className: PropTypes.string,
  international: PropTypes.bool,
};

export default Postcode;
